// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import router from './router'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

import '@/assets/static/theme/base_style.less'
import '@fortawesome/fontawesome'

import store from './store/index'

import * as echarts from 'echarts'

import promise from 'es6-promise'
// import 'url-search-params-polyfill'


import URLSearchParams from '@ungap/url-search-params'
Vue.prototype.$URLSearchParams = URLSearchParams

import apis from '@/apis/apis'
import axios from './libs/axios.lib'
import axiosH5 from './libs/axiosH5.lib'
import common from './libs/common'
import bus from './libs/bus'
import valideUtil from './libs/valideUtil'
import paramsCrypto from './libs/paramsCrypto'
import baseData from '@/libs/baseData'
import MD5 from '@/libs/md5'

//按钮权限
import './libs/btnPermissions'
//防抖
import './libs/debounce'

import moment from 'moment'
Vue.prototype.$moment = moment

// 需要全局注册的组件
import '@/components/index'
import '@/views/cockpitManage/cockpitComponets/cockpitComponents.js'

import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)

import GeminiScrollbar from 'vue-gemini-scrollbar'
Vue.use(GeminiScrollbar)

import Vuebar from 'vuebar'
Vue.use(Vuebar)

import VueSeamlessScroll from "vue-seamless-scroll"
Vue.use(VueSeamlessScroll)

// import VueCron from 'vue-cron'
// Vue.use(VueCron)  // 使用方式：<vueCron></vueCron>

import VueClipboard from "vue-clipboard2"
Vue.use(VueClipboard)

import * as filters from '@/filters/index'
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})


Vue.prototype.$echarts = echarts
Vue.config.productionTip = false

promise.polyfill()


// import VueWorker from 'vue-worker'
// Vue.use(VueWorker)

Vue.use(VueRouter)
// 全局配置参考 https://v4.iviewui.com/docs/guide/global
Vue.use(ViewUI, {
  transfer: true,
  capture: false,
  // size: 'large',
  select: {
    arrow: 'md-arrow-dropdown',
    arrowSize: 20
  },
  modal: {
    maskClosable: false
  },
  drawer: {
    maskClosable: false
  },
  message: {
    duration: 3
  }
})

Vue.use(axios)
Vue.use(axiosH5)
Vue.use(apis)
Vue.use(common)
Vue.use(bus)
Vue.use(valideUtil)
Vue.use(paramsCrypto)
Vue.use(baseData)
Vue.use(MD5)

// 获取数据字典
Vue.prototype.getDic = async function (category) {
  let that = this
  let data = sessionStorage.getItem("dic_" + category)
  if (data != undefined && data != '') {
    console.log(category + ' in sessionStorage')
    return JSON.parse(data)
  } else {
    data = []
    let params = new this.$URLSearchParams()
    params.append("category", category)
    await this.$axios.post(that.$apis.dictionaryManager.labelvalue.getDicByCategory, params).then((res) => {
      if (res.success) {
        data = res.result || []
        sessionStorage.setItem("dic_" + category, JSON.stringify(data))
      } else {
        that.$Message.error(res.message)
      }
    }).catch(function (err) {
      that.$Message.error("获取数据字典[" + category + "]失败！")
    })
    console.log('getDic', data)
  }
  return data
}

// 获取字典值
Vue.prototype.getDicLabel = async function (val, category) {
  console.log(category, val)
  let label = '--'
  if (val) {
    await this.getDic(category).then(values => {
      if (val instanceof Array) {
        let mid = []
        values.forEach(item => {
          if (val.indexOf(item.val) >= 0) mid.push(item.label)
        })
        label = mid.join('、')
      } else {
        values.forEach(item => {
          if (item.val == val) label = item.label
        })
      }
    })
  }
  console.log('getDicLabel', label)
  return label
}

//runtime

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
